import { render, staticRenderFns } from "./ControlAsistencia1.vue?vue&type=template&id=743223d5&scoped=true&"
import script from "./ControlAsistencia1.vue?vue&type=script&lang=js&"
export * from "./ControlAsistencia1.vue?vue&type=script&lang=js&"
import style0 from "./ControlAsistencia1.vue?vue&type=style&index=0&id=743223d5&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "743223d5",
  null
  
)

export default component.exports